import { StationMissingDataDailyModel } from '../models/station-missing-data-daily';

export class StationMissingDataDailyAdapter {
  static fromApi(data: any): StationMissingDataDailyModel {
    return {
      id: data.stationId, // Usar stationId como ID principal
      stationId: data.stationId,
      stationIdentifier: data.stationIdentifier,
      stationName: data.stationName,
      periodStart: data.periodStart,
      periodEnd: data.periodEnd,
      missingDates: data.missingDates || [],
    };
  }
}
